import { TeoError } from './errors/TeoError';
import type { UserDetail, UserRole } from './TeoApi';
import type { TeoCore } from './TeoCore';
import { TeoEventTarget } from './utility/TeoEventTarget';

type UserEvents = {
  logIn: (detail: User) => void;
  logInFailed: (detail: string) => void;
  logOut: (reset?: boolean) => void;
  logOutFailed: (detail: string) => void;
  userDataChanged: (detail: User) => void;
};

export class User {
  email: string | null = null;
  name: string | null = null;
  role: UserRole | null = null;
  private core: TeoCore;
  events = new TeoEventTarget<UserEvents>();

  private initializing?: Promise<void>;
  constructor(core: TeoCore) {
    this.core = core;
    this.init();
  }

  get isLoggedIn() {
    // TODO: besser wäre es den token zu prüfen
    return !!this.role;
  }

  async init() {
    if (this.initializing) return this.initializing;
    this.initializing = this.checkStorage();
  }

  private async checkStorage() {
    const user = await this.core.storage.loadUser();
    if (user) {
      const tokenCheck = await this.core.api.setApiToken(user.token);
      if (tokenCheck) {
        this.updateUserDetail(user);
        return;
      }
    }
    this.clearUserDetail();
  }

  async logIn(email: string, password: string) {
    const result = await this.core.api.logIn(email, password);
    if (TeoError.isError(result)) {
      this.updateUserDetail(null);
      this.events.triggerEvent('logInFailed', result.message);
      return;
    }
    this.updateUserDetail(result);
  }

  async logOut(reset = true) {
    const result = await this.core.api.logOut();
    if (TeoError.isError(result)) {
      this.events.triggerEvent('logOutFailed', result.message);
    }
    this.updateUserDetail(null, reset);
  }

  clearUserDetail() {
    this.updateUserDetail(null);
  }

  private updateUserDetail(userDetail: UserDetail | null, reset = true) {
    const wasLoggedIn = this.isLoggedIn;
    if (!userDetail) {
      // das ist faktisch ein logout
      this.email = null;
      this.name = null;
      this.role = null;
      this.core.storage.clearUser();
      // TODO: check that something really changed
      this.events.triggerEvent('userDataChanged', this);
      if (wasLoggedIn) {
        this.events.triggerEvent('logOut', reset);
      }
      return;
    }

    this.email = userDetail.email;
    this.name = userDetail.name;
    this.role = userDetail.role;
    this.core.storage.saveUser(userDetail);
    // TODO: check that something really changed
    this.events.triggerEvent('userDataChanged', this);
    if (!wasLoggedIn) {
      this.events.triggerEvent('logIn', this);
    }
  }
}
